import { render, staticRenderFns } from "./PortfolioArchives.vue?vue&type=template&id=a5d157aa&scoped=true&"
import script from "@/views/Users/Student/Progress/PortfolioArchives.ts?vue&type=script&lang=ts&"
export * from "@/views/Users/Student/Progress/PortfolioArchives.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Users/Student/Progress/progress-cito-results.scss?vue&type=style&index=0&id=a5d157aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d157aa",
  null
  
)

export default component.exports